import { Component } from '@angular/core';

import { DemoDataCardSettingsService } from '@demo/module-definition/demo-data-card-settings/demo-data-card-settings.service';
import { DataListViewAction } from '@models/module/main/dataListViewAction';
import { ScreenModel } from '@module-definition/screen/common';
import { DataCardSettingsComponent } from '@module-definition/data-card/data-card-settings/data-card-settings.component';
import { DataCardSettingsService } from '@module-definition/data-card/data-card-settings/data-card-settings.service';

@Component({
  selector: 'app-demo-data-card-settings.component',
  templateUrl: './demo-data-card-settings.component.html',
  providers: [{ provide: DataCardSettingsService, useClass: DemoDataCardSettingsService }],
  imports: [DataCardSettingsComponent],
})
export class DemoDataCardSettingsComponent {
  actions: DataListViewAction[] = [];

  screen: ScreenModel = {
    anyFieldInUse: false,
    id: 194,
    inUse: false,
    isStartScreen: false,
    name: 'Default',
    roleIds: [],
    type: 3,
    version: 1,
    versionCount: 1,
    versionId: 35,
  };
}
